module.exports = __webpack_public_path__ + "static/mfg-about_empire-1-min.9432d350.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/about/mfg-about_empire-1-min.png
// module id = 661
// module chunks = 49508567561676